module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-numeric-down-alt-7012b689.svg";